import React, { useEffect, useState } from 'react';
import { IAppState } from '../../types/appState.type';
import './FooterComponent.css';
import { useSelector, shallowEqual } from 'react-redux';
import { useTranslation } from 'react-i18next';

export const FooterComponent = () => {
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language;

	const { cookieBannerState } = useSelector(
		(state: IAppState) => state,
		shallowEqual
	);
	const { isConsentRequired } = cookieBannerState.consentValues;

	const manageCookies = (ev: React.MouseEvent<HTMLAnchorElement>) => {
		ev.preventDefault();

		if (!window || !window.siteConsent || !window.siteConsent.manageConsent)
			return;

		window.siteConsent.manageConsent();
	};

	return (
		<footer>
			<div className="footer-top row">
				<nav className="small-12 columns" aria-label="Footer Resource links">
					<div className="row xsmall-up-1 medium-up-3 large-up-6">
						<section className="columns">
			<h2 role="heading" aria-level={2}>{t('footerComponent.whatsNew')}</h2>
							<ul>
								<li>
									<a href="https://www.microsoft.com/en-us/p/surface-go-2/8PT3S2VJMDR6">
									{t('footerComponent.surfaceGo2')}
									</a>
								</li>
								<li>
									<a href="https://www.microsoft.com/en-us/p/surface-book-3/8XBW9G3Z71F1">
									{t("footerComponent.surfaceBook3")}
									</a>
								</li>
								<li>
									<a href="https://www.microsoft.com/microsoft-365">
									{t("footerComponent.microsoft365")}
									</a>
								</li>
								<li>
									<a href="https://www.microsoft.com/en-us/p/surface-pro-x/8vdnrp2m6hhc">
									{t("footerComponent.surfaceProX")}
									</a>
								</li>
								<li>
									<a href="https://www.microsoft.com/en-us/windows/windows-10-apps">
									{t("footerComponent.windows10Apps")}
									</a>
								</li>
							</ul>
						</section>
						<section className="columns">
			 <h2 role="heading" aria-level={2}>{t("footerComponent.microsoftStore")}</h2>
							<ul>
								<li>
									<a href="https://account.microsoft.com/">{t("footerComponent.accountProfile")}</a>
								</li>
								<li>
									<a href="https://www.microsoft.com/en-us/download">
									{t("footerComponent.downloadCenter")}
									</a>
								</li>
								<li>
									<a href="https://go.microsoft.com/fwlink/p/?LinkID=824761&clcid=0x409">
									{t("footerComponent.microsoftStoreSupport")}
									</a>
								</li>
								<li>
									<a href="https://go.microsoft.com/fwlink/p/?LinkID=824764&clcid=0x409">
									{t("footerComponent.returns")}
									</a>
								</li>
								<li>
									<a href="https://account.microsoft.com/orders">
									{t("footerComponent.orderTracking")}
									</a>
								</li>
								<li>
									<a href="https://www.microsoft.com/en-us/store/locations/find-a-store?icid=en-us_UF_FAS">
									{t("footerComponent.storeLocations")}
									</a>
								</li>
								<li>
									<a href="https://www.microsoft.com/en-us/store/b/buy-online-pick-up-in-store?icid=uhf_footer_bopuis">
									{t("footerComponent.buyOnlinePickUpInStore")}
									</a>
								</li>
								<li>
									<a href="https://www.microsoft.com/en-us/store/workshops-training-and-events?icid=bm_uhf_footer_virtual-learning-azure_692020">
									{t("footerComponent.virtualWorkshopsAndTraining")}
									</a>
								</li>
							</ul>
						</section>
						<section className="columns">
			<h2 role="heading" aria-level={2}>{t("footerComponent.education")}</h2>
							<ul>
								<li>
									<a href="https://www.microsoft.com/en-us/education">
									{t("footerComponent.microsoftInEducation")}
									</a>
								</li>
								<li>
									<a href="https://www.microsoft.com/en-us/education/products/office/default.aspx">
									{t("footerComponent.officeForStudents")}
									</a>
								</li>
								<li>
									<a href="https://products.office.com/en-us/academic/compare-office-365-education-plans">
									{t("footerComponent.office365ForSchools")}
									</a>
								</li>
								<li>
									<a href="https://www.microsoft.com/en-us/store/b/education?icid=CNavfooter_Studentsandeducation">
									{t("footerComponent.dealsForStudents&Parents")}
									</a>
								</li>
								<li>
									<a href="https://azure.microsoft.com/en-us/community/education/">
									{t("footerComponent.microsoftAzureInEducation")}
									</a>
								</li>
							</ul>
						</section>
						<section className="columns">
			<h2 role="heading" aria-level={2}>{t("footerComponent.enterprise")}</h2>
							<ul>
								<li>
									<a href="https://azure.microsoft.com/">{t("footerComponent.azure")}</a>
								</li>
								<li>
									<a href="https://go.microsoft.com/fwlink/?LinkID=808093">
									{t("footerComponent.appSource")}
									</a>
								</li>
								<li>
									<a href="https://www.microsoft.com/en-us/enterprise/automotive">
									{t("footerComponent.automotive")}
									</a>
								</li>
								<li>
									<a href="https://www.microsoft.com/en-us/enterprise/government">
									{t("footerComponent.government")}
									</a>
								</li>
								<li>
									<a href="https://www.microsoft.com/en-us/enterprise/health">
									{t("footerComponent.healthcare")}
									</a>
								</li>
								<li>
									<a href="https://www.microsoft.com/en-us/enterprise/manufacturing">
									{t("footerComponent.manufacturing")}
									</a>
								</li>
								<li>
									<a href="https://www.microsoft.com/en-us/enterprise/financial-services/banking-and-capital-markets">
									{t("footerComponent.financialServices")}
									</a>
								</li>
								<li>
									<a href="https://www.microsoft.com/en-us/enterprise/retail-consumer-goods">
									{t("footerComponent.retail")}
									</a>
								</li>
							</ul>
						</section>
						<section className="columns">
			<h2 role="heading" aria-level={2}>{t("footerComponent.developer")}</h2>
							<ul>
								<li>
									<a href="https://visualstudio.microsoft.com/">
									{t("footerComponent.microsoftVisualStudio")}
									</a>
								</li>
								<li>
									<a href="https://developer.microsoft.com/en-us/windows">
									{t("footerComponent.windowsDevCenter")}
									</a>
								</li>
								<li>
									<a href="https://msdn.microsoft.com/en-us">
									{t("footerComponent.developerNetwork")}
									</a>
								</li>
								<li>
									<a href="https://technet.microsoft.com/en-us">{t("footerComponent.techNet")}</a>
								</li>
								<li>
									<a href="https://developer.microsoft.com/en-us/store/register">
									{t("footerComponent.microsoftDeveloperProgram")}
									</a>
								</li>
								<li>
									<a href="https://channel9.msdn.com/">{t("footerComponent.channel9")}</a>
								</li>
								<li>
									<a href="https://developer.microsoft.com/en-us/office">
									{t("footerComponent.officeDevCenter")}
									</a>
								</li>
								<li>
									<a href="https://www.microsoft.com/en-us/garage/">
									{t("footerComponent.microsoftGarage")}
									</a>
								</li>
							</ul>
						</section>
						<section className="columns">
			<h2 role="heading" aria-level={2}>{t("footerComponent.company")}</h2>
							<ul>
								<li>
									<a href="https://careers.microsoft.com/">{t("footerComponent.careers")}</a>
								</li>
								<li>
									<a href="https://www.microsoft.com/en-us/about">
									{t("footerComponent.aboutMicrosoft")}
									</a>
								</li>
								<li>
									<a href="https://news.microsoft.com/">{t("footerComponent.companyNews")}</a>
								</li>
								<li>
									<a href="https://privacy.microsoft.com/en-us">
									{t("footerComponent.privacyAtMicrosoft")}
									</a>
								</li>
								<li>
									<a href="https://www.microsoft.com/investor/default.aspx">
									{t("footerComponent.investors")}
									</a>
								</li>
								<li>
									<a href="https://www.microsoft.com/en-us/diversity/">
									{t("footerComponent.diversityAndInclusion")}
									</a>
								</li>
								<li>
									<a href="https://www.microsoft.com/en-us/accessibility">
									{t("footerComponent.accessibility")}
									</a>
								</li>
								<li>
									<a href="https://www.microsoft.com/en-us/security/default.aspx">
									{t("footerComponent.security")}
									</a>
								</li>
							</ul>
						</section>
					</div>
				</nav>
			</div>
			<div className="footer-bottom row">
				<div
					className="xsmall-12 medium-2 columns"
					style={{ paddingLeft: 0 }}
					aria-label="Language selection"
				>
					<a href="/locale/">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 2048 2048"
							width={20}
							height={20}
							style={{
								display: 'inline-block',
								verticalAlign: 'middle',
								marginRight: '10px',
							}}
						>
							<path
								fill="currentColor"
								d="M496 883q13 0 29 4t32 11 32 13 29 12l-16 2q-8 1-17 1-17 0-31-5t-26-13-24-12-22-6q-10 0-18 4t-16 9q0-4-7-4 7-7 26-11t29-5zm135 45q41 0 75 14-14 5-28 8t-29 4q-20 0-36-4 5-8 10-10t8-12zM1024 0q141 0 271 37t244 103 208 161 160 207 104 244 37 272q0 141-37 271t-103 244-161 208-207 160-244 104-272 37q-141 0-271-37t-244-103-208-161-160-207-104-244-37-272q0-141 37-271t103-244 161-208 207-160T752 37t272-37zm762 555q-14-22-28-42t-29-41q-2 9-5 13t-4 18q0 9 7 17t18 16 22 12 19 7zm-69-98q0 8-3 11h6q4 0 6 1l-9-12zm-693 1463q114 0 223-29t206-82 180-130 145-172q-13-30-25-61t-12-64q0-36 3-58t7-39 4-29-3-31-17-41-37-62q1-7 3-19t4-25 1-24-5-19q-26-3-54-11t-50-24l6-5q-13 3-26 8t-25 11-26 8-27 4l-16-2 3-7q-14 4-30 10t-31 6q-10 0-29-7t-38-17-34-22-15-23l2-3q-5-6-13-11t-15-10-13-11-5-14l11-9-23-3-8-30q2 5 9 4t11-4l-36-19 25-64q-14-52-7-80t27-46 44-36 49-49l-3-12 66-80 15-2q28 0 63-2t71-7 71-10 64-13q-32-38-67-72t-75-65q-11 4-27 11t-32 18-25 24-11 27l6 19q-18 29-40 36t-45 8-48 0-48 9l-16-34 15-58-17-25 173-54q-11-28-36-42t-55-14v-10l56-9q-93-46-193-70t-205-24q-87 0-172 17t-164 49-153 80-135 108q26 0 40 13t26 29 25 29 35 14l16-12-2-22 33-47-26-74q5-3 15-10t17-7q30 0 46 3t28 11 21 23 28 38l36-28q10 4 32 13t45 22 39 27 17 26q0 15-11 24t-29 15-37 9-38 8-29 10-12 17l58 19q-20 17-43 31t-48 26l4 17-92 36v28l-7 3 5-35-4-1q-7 0-8 3t-1 7 2 8 1 6l-13-7 2 4q0 3 3 9t8 11 8 10 4 5q0 3-4 6t-10 4-8 3 0 1q14 0 6 2t-25 10-31 23-16 44q0 17 1 33t-1 33q-14-38-42-58t-68-20l-43 4 21 14q-17-2-35-4t-37-1-34 8-30 21l-6 45q0 32 14 52t49 21q30 0 59-9t57-21q-9 22-20 42t-16 44l13 6q24-16 44-5t39 32 39 43 43 32l-34 18-80-45q1 2 2 9t-1 3l-36-61q-32-1-68-10t-73-24-69-33-59-38l-7 107q0 122 33 238t93 218 147 186 193 143q-5-21-1-42t10-42 13-42 7-43q0-32-10-67t-24-71-31-71-27-66-16-58 6-47l-15-7q6-14 16-27t21-26 17-28 7-30q0-10-4-21t-7-21l21 5q17-39 46-53t73-15q5 0 21 4t34 11 34 11 24 8q0 7 8 9t9 7l-2 8q3 1 14 7t24 15 23 16 14 11q18 0 49 12t68 30 73 43 68 50 49 50 20 44l-34 36q4 51-7 78t-34 45-53 30-65 34q0 20-10 43t-25 44-36 35-42 14l-42-32q2 2 0 7t-5 2q10 19 5 44t-17 51-27 49-27 39q54 14 108 21t109 7z"
							/>
						</svg>
						{t("footerComponent.languageRegion")}
					</a>
				</div>
				<nav
					className="xsmall-12 medium-10 columns"
					aria-label="Microsoft corporate links"
				>
					<ul>
						<li>
							<a href="https://www.microsoft.com/en-us/sitemap1.aspx">
							{t("footerComponent.sitemaps")}
							</a>
						</li>
						<li>
							<a href="https://support.microsoft.com/en-us/contactus">
							{t("footerComponent.contactMicrosoft")}
							</a>
						</li>
						<li>
						<a 
							href="https://go.microsoft.com/fwlink/?LinkId=521839" 
							style={currentLanguage === 'ko-kr' ? {fontWeight: 'bold'} : {}}
						>
							{t("footerComponent.privacy&Cookies")}
						</a>
						</li>
						{isConsentRequired && (
							<li>
								<a
									onClick={manageCookies}
									id="manageCookies"
									href="#manageCookies"
								>
								{t("footerComponent.manageCookies")}
								</a>
							</li>
						)}
						<li>
							<a href="https://go.microsoft.com/fwlink/?LinkID=206977">
							{t("footerComponent.termsOfUse")}
							</a>
						</li>
						<li>
							<a href="https://www.microsoft.com/trademarks">{t("footerComponent.trademarks")}</a>
						</li>
						<li>
							<a href="https://www.microsoft.com/en-us/devices/safety-and-eco">
							{t("footerComponent.safety&Eco")}
							</a>
						</li>
						<li>
							<a href="https://choice.microsoft.com/">{t("footerComponent.aboutOurAds")}</a>
						</li>
						<li>
							<p style={{ margin: 0 }}>© Microsoft 2020</p>
						</li>
					</ul>
				</nav>
			</div>
		</footer>
	);
};
